import(/* webpackMode: "eager" */ "/vercel/path1/app/vocab/pool/page.tsx");
